import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import { FFContextProvider } from "@harnessio/ff-react-client-sdk";
import ReactGA4 from "react-ga4";
import LoginLoading from "./components/UI/LoginLoading";

import { withFeatureFlags } from "@harnessio/ff-react-client-sdk";

function MyComponent({ flags, loading }) {
  if (loading) {
    return <LoginLoading />;
  }
  return <App />;
}
const MyComponentWithFlags = withFeatureFlags(MyComponent);

const root = ReactDOM.createRoot(document.getElementById("root"));

const reactTarget = { name: "ReactClientSDK", identifier: "reactclientsdk" };
const sdkApiKey = process.env.REACT_APP_HARNESS_KEY;

const Environment = process.env.REACT_APP_ENV;
const TRACKING_ID = process.env.REACT_APP_ANALYTICS_KEY;
if (Environment === "prod") {
  ReactGA4.initialize(TRACKING_ID);
}
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <FFContextProvider async apiKey={sdkApiKey} target={reactTarget}>
          <MyComponentWithFlags />
        </FFContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
